import { auth } from '../config/firebase';

const ADMIN_BASE = (
  import.meta.env.VITE_ADMIN_PLATFORM_URL ||
  'https://unified-admin-n6hwviqtxa-nw.a.run.app'
).replace(/\/$/, '');

const APP_ID_ALIASES: Record<string, string> = {
  'financial-uk': 'financial',
  'project-management': 'projects',
  'ef-projex': 'projects',
  'ef-link': 'supply',
  'ef-capflow': 'financial',
  'ef-strategy': 'forceai',
};

const KNOWN_SSO_APPS = new Set([
  'forceai',
  'crm',
  'financial',
  'ascin',
  'efaipm',
  'projects',
  'supply',
]);

function appendQueryParam(url: string, key: string, value: string): string {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}${key}=${encodeURIComponent(value)}`;
}

export function getSsoAppId(appId: string): string {
  return APP_ID_ALIASES[appId] || appId;
}

export function canMintSso(appId: string): boolean {
  return KNOWN_SSO_APPS.has(getSsoAppId(appId));
}

export async function mintCustomToken(appId: string): Promise<string> {
  if (!auth.currentUser) {
    throw new Error('Please sign in again before switching apps.');
  }

  const idToken = await auth.currentUser.getIdToken(true);
  const response = await fetch(`${ADMIN_BASE}/api/v1/sso/mint`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify({ app_id: getSsoAppId(appId) }),
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    const detail =
      typeof body.detail === 'string' ? body.detail : 'Unable to authorize this app.';
    throw new Error(detail);
  }

  const data = (await response.json()) as { custom_token?: string };
  if (!data.custom_token) {
    throw new Error('The SSO service returned an invalid response.');
  }

  return data.custom_token;
}

export async function buildSsoLaunchUrl(appUrl: string, appId: string): Promise<string> {
  const customToken = await mintCustomToken(appId);
  return appendQueryParam(appUrl, 'customToken', customToken);
}
